import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Animated particles background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute w-1 h-1 bg-cyan-400 rounded-full animate-pulse" style={{ top: '20%', left: '10%', animationDelay: '0s' }}></div>
        <div className="absolute w-1 h-1 bg-cyan-400 rounded-full animate-pulse" style={{ top: '60%', left: '80%', animationDelay: '1s' }}></div>
        <div className="absolute w-1 h-1 bg-blue-400 rounded-full animate-pulse" style={{ top: '40%', left: '30%', animationDelay: '2s' }}></div>
        <div className="absolute w-1 h-1 bg-cyan-400 rounded-full animate-pulse" style={{ top: '80%', left: '60%', animationDelay: '1.5s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-8 py-32 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center relative z-10">
        {/* Left Content */}
        <div className={`space-y-8 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
          <div className="space-y-6">
            <p className="text-sm sm:text-base font-medium uppercase tracking-[0.22em] text-cyan-400">
              Modular Living Pods in Melbourne
            </p>
            <h1 className="text-7xl font-thin tracking-wider leading-tight">
              FUTURE LIVING,&nbsp;<br />
              <span className="text-cyan-400" style={{ textShadow: '0 0 30px rgba(0,217,255,0.6)' }}>GROUNDED</span> IN REALITY
            </h1>
            <p className="text-lg text-gray-400 max-w-xl leading-relaxed">
              Smart Modular Cabins for Premium Stays, Property Projects & Modern Living
            </p>
          </div>

          <div className="flex flex-col gap-4 max-w-md">
            <Link to="/product-range" className="group w-full px-8 py-4 bg-cyan-500 text-black font-medium rounded-full hover:bg-cyan-400 transition-all hover:shadow-[0_0_30px_rgba(0,217,255,0.6)] flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer">
              Explore Design
              <div className="w-8 h-8 bg-black rounded-full flex items-center justify-center">
                <i className="ri-arrow-right-line text-cyan-400 text-lg"></i>
              </div>
            </Link>
            <Link to="/contact" className="w-full px-8 py-4 text-gray-300 hover:text-cyan-400 transition-colors underline decoration-cyan-500/50 hover:decoration-cyan-400 whitespace-nowrap cursor-pointer text-center">
              Become a Partner
            </Link>
          </div>

          {/* Technical annotations */}
          <div className="pt-8 space-y-3">
            <div className="flex items-center gap-3 text-sm text-gray-500">
              <div className="w-2 h-2 bg-cyan-400 rounded-full shadow-[0_0_10px_rgba(0,217,255,0.8)]"></div>
              <span>Smart Climate Control System</span>
            </div>
            <div className="flex items-center gap-3 text-sm text-gray-500">
              <div className="w-2 h-2 bg-cyan-400 rounded-full shadow-[0_0_10px_rgba(0,217,255,0.8)]"></div>
              <span>Panoramic Smart Glass Technology</span>
            </div>
            <div className="flex items-center gap-3 text-sm text-gray-500">
              <div className="w-2 h-2 bg-cyan-400 rounded-full shadow-[0_0_10px_rgba(0,217,255,0.8)]"></div>
              <span>Modular Aerospace-Grade Frame</span>
            </div>
          </div>
        </div>

        {/* Right Visual */}
        <div className={`relative transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 blur-3xl rounded-full"></div>
            <img 
              src="/images/ai-futuristic-modular-space-capsule-living--76d56c.webp" 
              alt="Space Capsule Living Pod"
              className="relative z-10 w-full h-auto object-contain drop-shadow-2xl"
            />
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 animate-bounce">
        <i className="ri-arrow-down-line text-2xl text-cyan-400"></i>
      </div>
    </section>
  );
}
